<template @close="noticeModalHide">
  <transition name="modal" v-if="offerInfo">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <ValidationObserver ref="validationObserver" v-slot="{ invalid }">
          <div
            ref="myid"
            class="modal-container scroll-modal"
            v-scroll-lock="loaded"
          >
            <div
              ref="header"
              class="modal-header hero-image"
              :class="onlyConfirmed ? 'confirmed-image' : 'non-cofirmed-image'"
            >
              <h4 class="modal-title">
                {{ onlyConfirmed ? 'Radni nalog' : 'Kalkulacija' }}
              </h4>
              <md-button
                class="md-just-icon md-round modal-default-button"
                @click="noticeModalHide"
              >
                <md-icon>clear</md-icon>
              </md-button>
            </div>

            <div ref="body" class="modal-body text-center">
              <md-icon
                v-if="working || invalid"
                class="text-info status-icon working"
                >cached</md-icon
              >
              <md-icon v-else class="text-success status-icon done"
                >done</md-icon
              >
              <div class="instruction">
                <div class="md-layout">
                  <ValidationProviderExtended
                    name="Radni nalog"
                    rules="required|min:2"
                    className="md-layout-item md-size-100"
                  >
                    <label>Radni nalog</label>
                    <md-input
                      v-model="offerInfo.name"
                      type="text"
                      @blur="submitOffer"
                    ></md-input>
                  </ValidationProviderExtended>

                  <ValidationProvider
                    slim
                    ref="clientSearchValProvider"
                    v-slot="{ invalid, valid }"
                    rules="required|min_value:1"
                    class="md-layout-item md-size-50"
                    mode="passive"
                  >
                    <md-field
                      :class="[{ 'md-error': invalid }, { 'md-valid': valid }]"
                    >
                      <search-drop-down
                        :title="'Klijent'"
                        :items="clients"
                        :defaultValue="offerInfo.client.name || ''"
                        @updatedInput="searchClients"
                        @selected="selectClient"
                      />
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="invalid">close</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                  </ValidationProvider>
                  <md-field class="md-layout-item md-size-50">
                    <label>Kontakt osoba</label>
                    <md-select v-model="selectedContactPerson">
                      <md-option
                        v-for="(contactPerson, index) in contactPersons"
                        :key="index"
                        :value="contactPerson.id"
                        >{{ contactPerson.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                  <ValidationProvider
                    slim
                    name="Rok"
                    rules="required"
                    :class="
                      'md-layout-item ' +
                        (showDoneButton ? 'md-size-75' : 'md-size-100')
                    "
                    v-slot="{ valid, invalid }"
                  >
                    <md-field
                      :class="[{ 'md-error': invalid }, { 'md-valid': valid }]"
                    >
                      <label>Rok</label>
                      <md-datepicker v-model="offerInfo.deadline" />
                      <slide-y-down-transition>
                        <md-icon
                          class="error datepicker-validation-button"
                          v-show="invalid"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </ValidationProvider>

                  <md-field
                    v-if="showDoneButton"
                    class="md-layout-item md-size-25"
                  >
                    <div class="md-layout mx-auto">
                      <md-switch class="md-layout-item" v-model="offerInfo.done"
                        >Završeno</md-switch
                      >
                    </div>
                  </md-field>

                  <ValidationProviderExtended
                    name="Odgovorno lice"
                    rules="required"
                    className="md-layout-item md-size-50"
                  >
                    <label>Odgovorno lice</label>
                    <md-select v-model="offerInfo.inCharge.id">
                      <md-option
                        v-for="(user, index) in users"
                        :key="index"
                        :value="user.id"
                        >{{ `${user.firstName} ${user.lastName}` }}</md-option
                      >
                    </md-select>
                  </ValidationProviderExtended>
                  <md-field class="md-layout-item md-size-50">
                    <div class="md-layout md-layout-item md-size-100">
                      <div class="md-layout-item">
                        <label>Transport</label>
                        <md-input
                          v-model="offerInfo.transportDistance"
                          type="number"
                          @blur="submitOffer"
                        ></md-input>
                      </div>
                      <div class="md-layout-item input-append">
                        <span class="center-text"> km </span>
                      </div>
                    </div>
                  </md-field>
                  <drop-down
                    v-if="ready && !offerInfo.job"
                    class="md-layout-item job-placeholder"
                    direction="down"
                  >
                    <div>
                      <p class="middle-text md-simple">
                        <md-icon> add_circle </md-icon>
                        Dodaj posao
                      </p>
                    </div>

                    <ul class="dropdown-menu">
                      <li>
                        <router-link
                          :to="{ path: `job`, query: { offerId: 0 } }"
                        >
                          Tabačna štampa
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          :to="{
                            path: `large_format_job`,
                            query: { offerId: 0 },
                          }"
                        >
                          Veliki formati i ostalo
                        </router-link>
                      </li>
                    </ul>
                  </drop-down>

                  <stats-card
                    v-if="
                      offerInfo &&
                        offerInfo.job &&
                        offerInfo.job.type === 'arch_print'
                    "
                    header-color="blue"
                    class="box-shadow"
                  >
                    <template slot="header">
                      <div class="card-icon">
                        <md-icon>book</md-icon>
                      </div>
                      <h3 class="title">
                        {{ offerInfo.job.jobName }}
                      </h3>
                      <p class="job-info">Tabačna štampa</p>
                      <p
                        class="job-info"
                        v-if="
                          offerInfo.job.binding &&
                            offerInfo.job.binding.bindingType &&
                            offerInfo.job.binding.bindingType.bindingTypeName
                        "
                      >
                        Povez:
                        {{ offerInfo.job.binding.bindingType.bindingTypeName }}
                      </p>
                      <p class="job-info">
                        Format: {{ offerInfo.job.format.name }}
                      </p>
                      <p class="job-info">
                        Tiraž:
                        <animated-number
                          :value="offerInfo.job.circulations"
                        ></animated-number>
                      </p>
                    </template>

                    <template slot="footer">
                      <router-link
                        :to="{
                          path: `job`,
                          query: { offerId: $route.query.id },
                        }"
                      >
                        <md-button class="md-round md-just-icon">
                          <md-icon>create</md-icon>
                        </md-button>
                      </router-link>

                      <md-button
                        class="md-round md-just-icon md-danger"
                        @click="removeJob()"
                      >
                        <md-icon>delete</md-icon>
                      </md-button>
                      <div @click="setTotalDiscount()" class="ml-auto pricing">
                        <md-field v-if="settingDiscount">
                          <md-input
                            v-model="offerInfo.job.discountedPrice"
                            id="priceInput"
                            type="number"
                            @blur="setTotalDiscount('sendPrice')"
                          >
                          </md-input>
                        </md-field>
                        <div v-else>
                          <animated-number
                            :value="Math.floor(offerInfo.job.discountedPrice)"
                          >
                          </animated-number>
                          {{ showDecimal(offerInfo.job.discountedPrice) }}€
                          <span
                            v-if="
                              offerInfo.job.discountedPrice !=
                                offerInfo.job.totalPrice
                            "
                          >
                            (
                            <animated-number
                              :value="Math.floor(offerInfo.job.totalPrice)"
                            >
                            </animated-number>
                            {{ showDecimal(offerInfo.job.totalPrice) }}€ )
                          </span>
                        </div>
                      </div>
                    </template>
                  </stats-card>

                  <stats-card
                    v-else-if="
                      offerInfo &&
                        offerInfo.job &&
                        deriveType(offerInfo.job) === 'large_format'
                    "
                    header-color="rose"
                    class="box-shadow"
                  >
                    <template slot="header">
                      <div class="card-icon">
                        <md-icon>aspect_ratio</md-icon>
                      </div>
                      <h3 class="title">
                        {{ offerInfo.job.name }}
                      </h3>
                      <p class="job-info">Veliki format</p>
                      <p class="job-info">
                        {{ findItemFormat(offerInfo.job.jobItems, 'name') }}
                      </p>
                      <p class="job-info">
                        {{
                          findItemFormat(offerInfo.job.jobItems, 'circulations')
                        }}
                      </p>
                    </template>

                    <template slot="footer">
                      <router-link
                        :to="{
                          path: `large_format_job`,
                          query: { offerId: $route.query.id },
                        }"
                      >
                        <md-button class="md-round md-just-icon">
                          <md-icon>create</md-icon>
                        </md-button>
                      </router-link>
                      <md-button
                        class="md-round md-just-icon md-danger"
                        @click="removeJob(index)"
                      >
                        <md-icon>delete</md-icon>
                      </md-button>
                      <div @click="setTotalDiscount()" class="ml-auto pricing">
                        <md-field v-if="settingDiscount">
                          <md-input
                            v-model="offerInfo.job.discountedPrice"
                            id="priceInput"
                            type="number"
                            @blur="setTotalDiscount('sendPrice')"
                          >
                          </md-input>
                        </md-field>
                        <div v-else>
                          <animated-number
                            :value="Math.floor(offerInfo.job.discountedPrice)"
                          >
                          </animated-number>
                          {{ showDecimal(offerInfo.job.discountedPrice) }}€
                          <span
                            v-if="
                              offerInfo.job.discountedPrice !=
                                offerInfo.job.totalPrice
                            "
                          >
                            (
                            <animated-number
                              :value="Math.floor(offerInfo.job.totalPrice)"
                            >
                            </animated-number>
                            {{ showDecimal(offerInfo.job.totalPrice) }}€ )
                          </span>
                        </div>
                      </div>
                    </template>
                  </stats-card>

                  <stats-card
                    v-else-if="
                      offerInfo &&
                        offerInfo.job &&
                        deriveType(offerInfo.job) === 'design'
                    "
                    header-color="brand"
                    class="box-shadow"
                  >
                    <template slot="header">
                      <div class="card-icon">
                        <md-icon>architecture</md-icon>
                      </div>
                      <h3 class="title">
                        {{ offerInfo.job.name }}
                      </h3>
                    </template>

                    <template slot="footer">
                      <router-link
                        :to="{
                          path: `large_format_job`,
                          query: { offerId: $route.query.id },
                        }"
                      >
                        <md-button class="md-round md-just-icon">
                          <md-icon>create</md-icon>
                        </md-button>
                      </router-link>
                      <md-button
                        class="md-round md-just-icon md-danger"
                        @click="removeJob(index)"
                      >
                        <md-icon>delete</md-icon>
                      </md-button>
                      <div @click="setTotalDiscount()" class="ml-auto pricing">
                        <md-field v-if="settingDiscount">
                          <md-input
                            v-model="offerInfo.job.discountedPrice"
                            id="priceInput"
                            type="number"
                            @blur="setTotalDiscount('sendPrice')"
                          >
                          </md-input>
                        </md-field>
                        <div v-else>
                          <animated-number
                            :value="Math.floor(offerInfo.job.discountedPrice)"
                          >
                          </animated-number>
                          {{ showDecimal(offerInfo.job.discountedPrice) }}€
                          <span
                            v-if="
                              offerInfo.job.discountedPrice !=
                                offerInfo.job.totalPrice
                            "
                          >
                            (
                            <animated-number
                              :value="Math.floor(offerInfo.job.totalPrice)"
                            >
                            </animated-number>
                            {{ showDecimal(offerInfo.job.totalPrice) }}€ )
                          </span>
                        </div>
                      </div>
                    </template>
                  </stats-card>

                  <stats-card
                    v-else-if="
                      offerInfo &&
                        offerInfo.job &&
                        deriveType(offerInfo.job) === 'miscellaneous'
                    "
                    header-color="green"
                    class="box-shadow"
                  >
                    <template slot="header">
                      <div class="card-icon">
                        <md-icon>inventory</md-icon>
                      </div>
                      <h3 class="title">
                        {{ offerInfo.job.name }}
                      </h3>
                    </template>

                    <template slot="footer">
                      <router-link
                        :to="{
                          path: `large_format_job`,
                          query: { offerId: $route.query.id },
                        }"
                      >
                        <md-button class="md-round md-just-icon">
                          <md-icon>create</md-icon>
                        </md-button>
                      </router-link>
                      <md-button
                        class="md-round md-just-icon md-danger"
                        @click="removeJob()"
                      >
                        <md-icon>delete</md-icon>
                      </md-button>
                      <div @click="setTotalDiscount()" class="ml-auto pricing">
                        <md-field v-if="settingDiscount">
                          <md-input
                            v-model="offerInfo.job.discountedPrice"
                            id="priceInput"
                            type="number"
                            @blur="setTotalDiscount('sendPrice')"
                          >
                          </md-input>
                        </md-field>
                        <div v-else>
                          <animated-number
                            :value="Math.floor(offerInfo.job.discountedPrice)"
                          >
                          </animated-number>
                          {{ showDecimal(offerInfo.job.discountedPrice) }}€
                          <span
                            v-if="
                              offerInfo.job.discountedPrice !=
                                offerInfo.job.totalPrice
                            "
                          >
                            (
                            <animated-number
                              :value="Math.floor(offerInfo.job.totalPrice)"
                            >
                            </animated-number>
                            {{ showDecimal(offerInfo.job.totalPrice) }}€ )
                          </span>
                        </div>
                      </div>
                    </template>
                  </stats-card>
                </div>
              </div>

              <div ref="footer" class="modal-footer md-layout">
                <md-button class="md-success modal-button" @click="submitOffer">
                  <span class="md-label">
                    <md-icon class="material-icons">done</md-icon>
                  </span>
                  Primijeni
                </md-button>

                <md-button
                  :disabled="offerIncomplete"
                  class="md-success modal-button"
                  @click="saveOffer"
                >
                  <span class="md-label">
                    <md-icon class="material-icons">save</md-icon>
                  </span>

                  Sačuvaj</md-button
                >
              </div>

              <md-field>
                <md-textarea
                  placeholder="Napomena..."
                  v-model="offerInfo.comment"
                >
                </md-textarea>
              </md-field>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </transition>
</template>
<script>
import api from '../api/api.js';
import services from '@/api/services';
import StatsCard from '@/components/Cards/StatsCard.vue';
import AnimatedNumber from '@/components/AnimatedNumber.vue';
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
import Swal from 'sweetalert2';
import { SlideYDownTransition } from 'vue2-transitions';
import { getAsDate } from '@/utils/helpers';
import { roundTo } from '../utils/helpers.js';
export default {
  name: 'offer-modal',
  components: {
    StatsCard,
    AnimatedNumber,
    ValidationProviderExtended,
    SlideYDownTransition,
  },
  props: {
    id: Number,
  },
  computed: {
    loaded() {
      return this.clients !== null && this.users !== null;
    },
    selectedContactPerson: {
      get() {
        if (this.offerInfo.client?.pickContactPerson?.id)
          return this.offerInfo.client.pickContactPerson.id;
        return null;
      },
      set(value) {
        this.offerInfo.client.pickContactPerson = {
          id: value,
        };
        this.submitOffer();
      },
    },
    onlyConfirmed() {
      return this.$route.query.filter === 'confirmed';
    },
    showDoneButton() {
      return !!this.offerInfo.id && this.onlyConfirmed;
    },
    offerIncomplete() {
      return !this.offerInfo || !this.offerInfo.job || this.invalid;
    },
  },
  data() {
    return {
      clients: [],
      users: [],
      contactPersons: [],
      scrollable: false,
      offerInfo: {
        id: null,
        name: null,
        client: {
          id: null,
          name: null,
          pickContactPerson: {
            id: null,
            name: null,
          },
        },
        transportDistance: 0,
        inCharge: {
          id: null,
        },
        deadline: null,
      },
      ready: false,
      working: false,
      settingDiscount: null,
    };
  },
  methods: {
    selectClient(value) {
      this.offerInfo.client = value;
      this.validateClient();
      this.getContactPersons(this.offerInfo.client.id);
      this.selectedContactPerson = null;
      this.submitOffer();
    },
    validateClient() {
      this.$refs.clientSearchValProvider.validate(this.offerInfo.client.id);
    },
    getContactPersons(value) {
      api
        .get(services.offers.getContactPerson, {
          loadContactPersons: true,
          clientId: value,
        })
        .then(data => {
          this.contactPersons = data;
        });
    },
    noticeModalHide() {
      this.$emit('modal-hide', true);
    },
    searchClients(value) {
      api
        .get(services.getClient, {
          loadClient: true,
          clientName: value,
          isClient: true,
        })
        .then(data => {
          this.clients = data;
        });
    },
    editJob(jobType) {
      const offerId = this.offerInfo.id;
      if (jobType === 'arch_print') {
        this.$router.push({ path: `job`, query: { offerId } });
      } else if (jobType === 'large_format') {
        this.$router.push({
          path: `large_format_job`,
          query: { offerId },
        });
      }
    },
    removeJob() {
      api
        .post(services.job.removeJob, { removeJob: true })
        .then(data => {
          this.offerInfo = data;
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    submitOffer() {
      const requestParams = {};
      requestParams.mainPriceCalc = true;
      if (!this.isValid()) return;

      if (this.offerInfo.name !== null)
        requestParams.name = this.offerInfo.name;
      if (this.offerInfo.client.id !== null)
        requestParams.clientId = this.offerInfo.client.id;
      if (this.offerInfo.client?.pickContactPerson?.id)
        requestParams.contactPersonId = this.offerInfo.client.pickContactPerson.id;
      if (this.offerInfo.transportDistance !== null)
        requestParams.transportDistance = this.offerInfo.transportDistance;

      if (this.offerInfo.deadline !== null) {
        requestParams.deadline = getAsDate(this.offerInfo.deadline);
      }
      if (this.offerInfo.inCharge.id !== null)
        requestParams.inChargeUserId = this.offerInfo.inCharge.id;
      if (this.offerInfo.comment !== null)
        requestParams.comment = this.offerInfo.comment;
      if (this.offerInfo.done !== null)
        requestParams.done = this.offerInfo.done;

      return api
        .post(services.offers.submitOfferInfo, requestParams)
        .then(data => {
          if (data.ready) this.ready = data.ready;
          this.working = false;
          return data;
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    isValid() {
      return this.$refs.validationObserver.flags.valid;
    },
    saveOffer() {
      return this.submitOffer().then(data => {
        if (data.ready) {
          return Swal.fire({
            title: 'Sačuvaj izmjene?',
            text: `Da li ste sigurni da želite da sačuvate izmjene na ponudi?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'md-button md-success btn-fill',
            cancelButtonClass: 'md-button md-danger btn-fill',
            confirmButtonText: 'Sačuvaj!',
            cancelButtonText: 'Otkaži',
            buttonsStyling: false,
          }).then(data => {
            if (data.value) {
              return api
                .post(services.offers.saveOffer, { saveOffer: true })
                .then(() => {
                  this.$emit('saved-offer', true);
                })
                .catch(error => {
                  this.alertError(error);
                });
            }
          });
        }
      });
    },
    showDecimal(num) {
      const decimal = roundTo(num - Math.floor(num), 2);
      return decimal === 0 ? '.00' : `.${String(decimal).substring(2, 4)}`;
    },
    findItemFormat(jobItems, arg) {
      const paperItem = jobItems.find(el => {
        return el.params.type === 'big_print_paper';
      });
      if (paperItem !== null) {
        if (arg === 'name')
          return (
            paperItem.params.label +
            ' ' +
            new Intl.NumberFormat().format(
              paperItem.params.params.height / 100,
            ) +
            ' m X ' +
            new Intl.NumberFormat().format(
              paperItem.params.params.width / 100,
            ) +
            ' m'
          );
        else if (arg === 'circulations')
          return 'Tiraž: ' + paperItem.params.params.circulations;
      }
    },
    setTotalDiscount(action = null) {
      if (action === null) {
        this.settingDiscount = true;
        window.setTimeout(() => {
          const input = document.getElementById('priceInput');
          input.focus();
        }, 100);
      } else if (action === 'sendPrice') {
        this.settingDiscount = false;
        api
          .post(services.job.jobTotalDiscount, {
            newPrice: this.offerInfo.job.discountedPrice,
          })
          .catch(error => {
            this.alertError(error);
          });
      }
    },
    deriveType(job) {
      if (job.type === 'large_format') {
        if (
          job.jobItems.find(element => {
            return element.params.type === 'big_print_paper';
          })
        ) {
          return 'large_format';
        } else if (
          job.jobItems.find(element => {
            return element.params.type === 'design';
          })
        ) {
          return 'design';
        } else {
          return 'miscellaneous';
        }
      }
    },
  },
  mounted() {
    const queryId = parseInt(this.$route.query?.id) || 0;

    api
      .get(services.getSession, { getSession: true })
      .then(async ({ offerInfo }) => {
        if (offerInfo && offerInfo.id === queryId) {
          this.offerInfo = offerInfo;
        } else if (queryId) {
          this.offerInfo = await api.get(services.getOffer, {
            offerId: queryId,
          });
        } else if (offerInfo?.id) {
          api.post(services.offers.deleteOffer, { deleteCachedOffer: true });
        } else if (offerInfo) {
          this.offerInfo = offerInfo;
        }
      })
      .then(() =>
        api.get(services.getClient, {
          loadClient: true,
          clientName: this.offerInfo.client?.name ?? '',
        }),
      )
      .then(clients => {
        this.clients = clients;

        return api.get(services.getUsersSelect, { getUsers: true });
      })
      .then(users => {
        this.users = users;

        if (this.offerInfo.client?.id)
          this.getContactPersons(this.offerInfo.client.id);
      });
  },
  watch: {
    offerInfo: {
      handler(to, from) {
        if (from) this.working = true;
        this.validateClient();
      },
    },
  },
};
</script>
<style scoped>
.modal-title {
  color: white;
  font-size: 3em;
  position: absolute;
  top: 2rem;
  text-shadow: 0px 0px 7px #cecece;
}
.modal-container {
  position: relative;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 0;
  border: 0;
  border-radius: 0;
  outline: 0;
  height: 900px;
  overflow: scroll;
  scroll-behavior: smooth;
}
.modal-container::-webkit-scrollbar {
  display: none;
}
.confirmed-image {
  background-image: url('https://i1.adis.ws/i/canon/dig_book_print_hero_1280x768?w=1199&sm=aspect&aspect=16:9&qlt=80&fmt=jpg&fmt.options=interlaced&bg=rgb(255,255,255)');
}
.non-cofirmed-image {
  background-image: url('https://wallpaperset.com/w/full/c/d/2/102321.jpg');
}
.hero-image {
  background-color: white;
  height: 190px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  padding-top: 100px;
}
.md-input {
  width: 100%;
}
.status-icon {
  position: absolute;
  right: 20px;
  top: 200px;
  z-index: 1200;
}
.working {
  animation: rotate 1s linear infinite;
}
.datepicker-validation-button {
  margin-right: 2em;
  margin-top: 0.7em;
}
.modal-button {
  min-width: 140px;
}
.input-append {
  position: relative;
  padding: 7px 0px 3px 0px;
}
.input-append * {
  position: absolute;
  left: 0px;
}
.card-icon {
  float: right !important;
}
.job-placeholder {
  height: 12em;
  border: 0.5em dashed rgba(68, 68, 68, 0.7);
  border-radius: 2em;
  margin: 2em;
  transition: all 0.5s ease-in-out;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 0%,
    rgba(230, 230, 230, 1) 95%,
    rgba(204, 204, 204, 1) 100%
  );
  background-size: 500%;
  background-position-x: 50%;
  cursor: pointer;
}
.job-placeholder:hover {
  margin: 2em 1.5em;
  box-shadow: 0px 0px 1em 0.5em #aaaaaa;
  background-size: 100%;
}
.job-placeholder .dropdown-menu {
  top: 5em;
  left: 40%;
}

.pricing {
  font-size: 2em;
  padding: 5px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}
.pricing:hover {
  color: red;
}
.middle-text {
  margin-top: 2em;
}
.jobs-array {
  width: 100%;
  margin-top: 50px;
}
.job-info {
  margin: 5px;
}
.modal-footer {
  justify-content: space-evenly;
}
.box-shadow {
  box-shadow: 0px 0px 20px #8d8d8d;
}
.rotate-45 {
  transform: rotate(45deg);
}
.scroll-down-button {
  position: absolute;
  background-color: rgba(93, 93, 93, 0.1) !important;
  bottom: 17%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  animation: mymove 2s;
  animation-iteration-count: infinite;
  animation-delay: 2s;
}
.scroll-down-button:hover {
  background-color: rgba(93, 93, 93, 0.8) !important;
}
@keyframes mymove {
  0% {
    transform: translate(-50%, 0);
  }
  50% {
    transform: translate(-50%, 5px);
  }
  100% {
    transform: translate(-50%, 0);
  }
}
</style>
